import { render, staticRenderFns } from "./TelMarketStatistics.vue?vue&type=template&id=a9b22710&scoped=true&"
import script from "./TelMarketStatistics.vue?vue&type=script&lang=js&"
export * from "./TelMarketStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TelMarketStatistics.vue?vue&type=style&index=0&id=a9b22710&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b22710",
  null
  
)

export default component.exports